// @flow
import React from "react";
import TextPage from "../Tournament/TextPage";

export default ({ locale }) => <TextPage locale={locale} />;



// WEBPACK FOOTER //
// ./src/components/Tournaments/AboutTournaments.js